import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { UserDelegationTargetTypeEnum } from '@zaoblako/shared/modules/security/enums/user-delegation-target-type.enum';
import { UserDelegationTargetTypeEnumI18n } from '@zaoblako/shared/modules/security/i18n/user-delegation-target-type-enum.i18n';

@Pipe({
  name: 'userDelegationTargetTypeName',
  standalone: true
})
export class UserDelegationTargetTypeNamePipe implements PipeTransform {
  public transform(type: UserDelegationTargetTypeEnum): string {
    return UserDelegationTargetTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
